<template>
  <md-card-content>
    <md-progress-bar
      class="md-primary mt24"
      md-mode="indeterminate"
    />
    <p style="text-align:center">Estamos procesando la información, espere un momento</p>
  </md-card-content>
</template>
<script>
export default {
  name: "Loading"
};
</script>